import React, { useEffect, useState, useRef } from 'react';
import * as S from './style';
import { useHeaderStates } from '../../Providers/HeaderStates';
import { useStartupState } from '../../Providers/StartupState';
import ZoomInIcon from '@mui/icons-material/ZoomIn';

import { ModalCustom } from '../../components/ModalCustom';

import { Loading } from '../../components/Loading';
import { baseUrlImg, handleGetData } from '../../Api';
import { ReactMarkdown } from 'react-markdown/lib/react-markdown';
import ScrollMouseMUI from '../../components/ScrollMouseMUI';

// Capulho de algodão no traço dos ícones lucide (que não tem algodão): a
// Copasul nasceu de 27 produtores de algodão.
const Algodao = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    {/* três gomos: o de cima fica atrás dos dois de baixo */}
    <path d="M8.5 7a3.5 3.5 0 0 1 7 0" />
    <path d="M4.6 12.2a4 4 0 1 1 7.3.9" />
    <path d="M19.4 12.2a4 4 0 1 0-7.3.9" />
    {/* brácteas: a borda ondulada que abraça os gomos, e a cuia por baixo */}
    <path d="M4.6 12.2c2-.8 4.7-.2 6.2 1.6l1.2 1.4 1.2-1.4c1.5-1.8 4.2-2.4 6.2-1.6" />
    <path d="M4.6 12.2c.4 3 3.6 4.8 7.4 5.3 3.8-.5 7-2.3 7.4-5.3" />
    {/* talo curvo */}
    <path d="M12 17.5c0 2 .8 3.4 2.3 4.2" />
  </svg>
);

export const OurHistory = () => {
  const [data, setData] = useState(null);
  const [cardActive, setCardActive] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [srcModal, setSrcModal] = useState(false);

  const { setTitle, setBgHeader } = useHeaderStates();
  const { token, setError, setLoading } = useStartupState();

  // Parallax da foto do banner.
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const timelineRef = useRef(0);
  const [animateCard, setAnimateCard] = useState(true);

  const handleActiveCard = (index) => {
    setCardActive(index);

    const container = timelineRef.current;
    const target = document.getElementById(`timeline-btn-${index}`);

    if (container && target) {
      const containerRect = container.getBoundingClientRect();
      const targetRect = target.getBoundingClientRect();
      const offset = targetRect.left - containerRect.left - (container.clientWidth / 2) + (target.clientWidth / 2);

      container.scrollBy({
        left: offset,
        behavior: 'smooth'
      });
    }

    setCardActive(index);
    setAnimateCard(false);

    setTimeout(() => {
      setAnimateCard(true);
    }, 10);
  };

  const handleOpenModal = (src) => {
    setOpenModal(!openModal);
    setSrcModal(src);
  };

  useEffect(() => {
    setError(null);
    setLoading(true);

    if (token) {
      handleGetData(token, 'api/content/copasul/nossahistoria/')
        .then((response) => {
          setData(response?.data?.items[0]?.data);
          if (response?.status !== 200) {
            throw new Error(response.message);
          }
        })
        .catch((e) => {
          setData(null);
          console.log(e.message);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [token, setError, setLoading]);

  // A página tem o próprio banner: a faixa verde com o título, que o Header
  // desenha a partir do setTitle, fica desligada (como na Home e na Galeria).
  useEffect(() => {
    setTitle(null);
    setBgHeader(null);
  }, [setTitle, setBgHeader]);

  return data ? (
    <S.Container>
      <S.Banner>
        {/* sobre foto não há cor para medir: o tom vai explícito */}
        <S.TrilhaNoBanner tom="escuro" />
        <S.BannerBackground
          style={{
            backgroundImage: `url(${baseUrlImg}${data?.bannerPrincipal?.iv?.imagemBackground?.[0] ?? ''})`,
            transform: `translateY(${scrollY * 0.5}px)`,
          }}
        />
        <S.BannerOverlay />
        <S.BannerContent>
          <S.AnimatedWrapper>
            <S.Badge>{data?.bannerPrincipal?.iv?.subtitulo}</S.Badge>
          </S.AnimatedWrapper>
          <h1>{data?.bannerPrincipal?.iv?.titulo}</h1>
          <p>{data?.bannerPrincipal?.iv?.conteudoMarkdown}</p>
        </S.BannerContent>
        <ScrollMouseMUI />
      </S.Banner>

      <ModalCustom open={openModal} handleClose={handleOpenModal}>
        <S.ModalImage src={`${baseUrlImg}${srcModal}`} alt="Imagem ampliada" />
      </ModalCustom>

      <S.OrigemWrapper>
        <S.OrigemContainer>
          <S.OrigemContent>
            <S.OrigemBadge>{data?.MenuOrigem?.iv?.SubTitulo}</S.OrigemBadge>
            <S.OrigemTitle>{data?.MenuOrigem?.iv?.Titulo}</S.OrigemTitle>
            <S.OrigemDescription>
              <p>
                {data?.MenuOrigem?.iv?.ConteudoA}
              </p>
              <p>
                {data?.MenuOrigem?.iv?.ConteudoB}
              </p>
            </S.OrigemDescription>
            <S.OrigemStats>
              <div>
                <S.OrigemStatNumber>{data?.MenuOrigem?.iv?.Numero}+</S.OrigemStatNumber>
                <S.OrigemStatLabel>Cooperados</S.OrigemStatLabel>
              </div>
              <div>
                <S.OrigemStatNumber>
                  {(() => {
                    const birthDate = new Date(1978, 11, 16);
                    const today = new Date();

                    let age = today.getFullYear() - birthDate.getFullYear();
                    const hasBirthdayPassed =
                      today.getMonth() > birthDate.getMonth() ||
                      (today.getMonth() === birthDate.getMonth() && today.getDate() >= birthDate.getDate());

                    if (!hasBirthdayPassed) {
                      age -= 1;
                    }
                    return age;
                  })()}
                </S.OrigemStatNumber>

                <S.OrigemStatLabel>Anos de História</S.OrigemStatLabel>
              </div>
            </S.OrigemStats>
          </S.OrigemContent>
          <S.OrigemImageWrapper>
            <S.OrigemImagePlaceholder
              style={{
                backgroundImage: `url(${baseUrlImg}${data?.MenuOrigem?.iv?.Imagem ?? ''})`
              }}
            >
              <Algodao />
            </S.OrigemImagePlaceholder>
          </S.OrigemImageWrapper>

        </S.OrigemContainer>
      </S.OrigemWrapper>

      {/* verde-claro das seções alternadas da Home; a seção seguinte é branca */}
      <S.Section bg="#ddeae2">
        <S.BadgeTitle>Linha do Tempo</S.BadgeTitle>
        <S.TimelineHeader>
          {/* o título vem do Squidex (subtituloPagina); vazio, fica o padrão */}
          <h2>{data?.subtituloPagina?.iv || 'Nossa trajetória'}</h2>
          <p>Cada etapa representa conquistas fundamentais da nossa trajetória.</p>
        </S.TimelineHeader>

        <S.TimelineNav ref={timelineRef}>
          {data?.linhaDoTempo?.iv.map((item, index) => (
            <button
              id={`timeline-btn-${index}`}
              key={index}
              onClick={() => handleActiveCard(index)}
              className={cardActive === index ? 'active' : ''}
            >
              {item?.cartao?.titulo}
            </button>
          ))}
        </S.TimelineNav>

        <S.TimelineContent>
  <S.Card className={animateCard ? 'animate' : ''}>
    <S.CardHeader>
      <S.CardYear>
        {data?.linhaDoTempo?.iv[cardActive]?.cartao?.titulo}
      </S.CardYear>
      <S.CardTitle>
        {data?.linhaDoTempo?.iv[cardActive]?.cartao?.subTitulo}
      </S.CardTitle>
    </S.CardHeader>

    <S.CardText>
      <ReactMarkdown>
        {data?.linhaDoTempo?.iv[cardActive]?.cartao?.subConteudo?.conteudoMarkdown}
      </ReactMarkdown>
    </S.CardText>

    {data?.linhaDoTempo?.iv[cardActive]?.cartao?.subConteudo?.imagens.length > 0 && (
      <S.Gallery>
        {data?.linhaDoTempo?.iv[cardActive]?.cartao?.subConteudo?.imagens.map((item, index) => (
          <S.ImgButton key={index} onClick={() => handleOpenModal(item.imagem[0])}>
            <img src={`${baseUrlImg}${item.imagem}`} alt="" />
            <ZoomInIcon />
          </S.ImgButton>
        ))}
      </S.Gallery>
    )}
  </S.Card>
</S.TimelineContent>

      </S.Section>

      <S.ValoresWrapper>
        <S.ValoresBadge>{data?.NossosValores?.iv[0]?.Subtitulo}</S.ValoresBadge>
        <S.ValoresTitle>{data?.NossosValores?.iv[0]?.Titulo}</S.ValoresTitle>

        <S.ValoresGrid>
          {data?.NossosValores?.iv[0]?.NossosValores?.CardIndustrias?.map((item, index) => (
            <S.ValorCard key={index}>
              <S.ValorIconWrapper>
                <img src={`${baseUrlImg}${item.Imagem[0]}`} alt={item.Titulo} />
              </S.ValorIconWrapper>
              <S.ValorTitle>{item.Titulo}</S.ValorTitle>
              <S.ValorDescription>{item.Subtitulo}</S.ValorDescription>
            </S.ValorCard>
          ))}
        </S.ValoresGrid>
      </S.ValoresWrapper>

    </S.Container>
  ) : <Loading />;
};
